import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import AuthTemplate from "../../templates/Auth";
import api from "../../services/api";

import Input from "../../components/Input";
import Button from "../../components/Button";
import { logout, setToken, setUser, setPlan, setTheme, setData } from "../../services/auth";
import { setOverdueAlert } from "../../services/overdueAlert";
import { renderError } from "../../helpers/errors";
import { Link } from "react-router-dom";

export const Login = () => {
    const [loading, setLoading] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [recaptchaToken, setRecaptchaToken] = useState('');

    const recaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;

    useEffect(() => {
        logout();

        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(recaptchaKey, { action: 'login' })
                    .then(token => {
                        setRecaptchaToken(token);
                        setLoading(false);
                    })
                    .catch(error => {
                        console.error('Erro ao gerar token do reCAPTCHA:', error);
                        toast.error('Erro ao carregar o reCAPTCHA');
                        setLoading(false);
                    });
            });
        };

        return () => {
            document.body.removeChild(script);
        };
    }, [recaptchaKey]);

    const signIn = () => {
        if (!recaptchaToken) {
            toast.error("Erro ao carregar o reCAPTCHA.");
            return;
        }

        setLoading(true);

        api.post(`/login`, { 
            email, 
            password, 
            recaptcha_token: recaptchaToken
        }).then(res => {
            setToken(res.data.token);
            setUser(res.data.admin);
            // Valor inicial da sessão; a partir daqui o header X-Overdue-Alert
            // de cada resposta mantém o aviso atualizado.
            setOverdueAlert(res.data.overdue_alert_level);
            setPlan(res.data.plan);
            setTheme(res.data.theme);
            setData(res.data.data);
            window.location.href = "/";
        }).catch(error => {
            renderError(error);

            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(recaptchaKey, { action: 'login' })
                    .then(token => setRecaptchaToken(token))
                    .catch(error => {
                        console.error('Erro ao gerar token do reCAPTCHA:', error);
                        toast.error('Erro ao carregar o reCAPTCHA');
                    });
            });
        }).finally(() => setLoading(false));
    };

    return (
        <AuthTemplate>
            <h3>Entre na sua conta</h3>
            <Input type={`email`} label={`E-mail`} change={setEmail} value={email} placeholder={"Informe seu e-mail"} action={signIn} />
            <Input type={`password`} label={`Senha`} change={setPassword} value={password} placeholder={"Informe sua senha"} action={signIn} />
            <Button type={`primary`} text={`Entrar`} full={true} svg={`arrow-right-white`} loading={loading} action={signIn} />
            <span>
                Esqueceu sua senha?
                <Link to="/password-recovery" state={{ email }} className="mt-4 text-sm text-blue-600">
                    Recupere aqui
                </Link>
            </span>
        </AuthTemplate>
    );
};

export default Login;